import Component from 'inferno-component';

class Card extends Component {
  render() {
    const { themeColor } = this.props;
    const cardClass= themeColor ? `card card--${themeColor}` : `card`;
    return (
      <div className={cardClass}>
        <div className="card__inner--wrapper">
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Card;



// WEBPACK FOOTER //
// ./src/components/Card.js